import { Injectable } from '@angular/core';
import { AccountServiceWebProvider } from '@web-services/user/account.service';
import { User, UserSubscription } from '@models/models';

@Injectable()
export class UserServiceWebProvider {
	user: User;
	subscription: UserSubscription;

	constructor(private accountService: AccountServiceWebProvider) {
		this.getUser();
		// this.getSubscription();
	}

	get userData(): User {
		return this.user;
	}

	get subscriptionData() {
		return this.subscription;
	}

	get userCurrencyCode() {
		if (typeof this.user !== 'undefined') {
			return this.user.currency.currencyCode;
		}
		return '';
	}

	get userCurrencySymbol() {
		if (
			typeof this.user !== 'undefined' &&
			typeof this.user.currency !== 'undefined'
		) {
			return this.user.currency.symbol;
		}
		return '';
	}

	private getUser(): void {
		this.accountService.userDataObservable.subscribe((user: User) => {
			if (user !== null && typeof user !== 'undefined' && user.id !== null) {
				this.user = user;
			}
		});
	}

	// TODO remove after implementing Stripe v3 mobile
	// private getSubscription(): void {
	// 	this.accountService.userSubscriptionObservable.subscribe(subscription => {
	// 		if (subscription !== null && typeof subscription !== 'undefined') {
	// 			this.subscription = subscription;
	// 		}
	// 	});
	// }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/services/user/user.service.ts